<template>
  <CalicoExpiredVerificationLink />
</template>

<script lang="js">
import CalicoExpiredVerificationLink from '@/components/verificationExpired/index.vue'

export default {
  name: 'ExpiredVerificationLinkPage',
  components: {
    CalicoExpiredVerificationLink,
  }
}
</script>
<style lang="scss">
</style>